export const CUSTOM_ACTIONS = {
    DASHBOARD_BOUNCE_PAGE_LOADED: 'dashboard.bounce-page',
    DASHBOARD_ACTIVATE_PAGE_SUCCESS: 'dashboard.activate-page-success',
    DASHBOARD_ACTIVATE_PAGE_FAILURE: 'dashboard.activate-page-failure',
    DASHBOARD_PAGE_LOADED: 'dashboard.dashboard-page',
    DASHBOARD_BOUNCE_TO_GOLDENEYE: 'dashboard.bounce-to-goldeneye',
    DASHBOARD_BOUNCE_TO_BLEND: 'dashboard.bounce-to-blend',
    DASHBOARD_BOUNCE_TO_DASHBOARD: 'dashboard.bounce-to-dashboard',
    DASHBOARD_START_BLEND_ERROR: 'dashboard.start-blend-error',
    DASHBOARD_START_BLEND_SUCCESS: 'dashboard.start-blend-success',
    DASHBOARD_START_DIGITAL_PREAPPROVAL_SUCCESS: 'dashboard.start-digital-preapproval-success',
    DASHBOARD_START_DIGITAL_PREAPPROVAL_ERROR: 'dashboard.start-digital-preapproval-error',
    MIGRATION_REDIRECT: 'dashboard.migration-redirect',
    AUTHENTICATION_START: 'homeloansdashboard.dashboard.auth.session-start',
};
